module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_0@3x.48f0857f.png";